module.exports = __webpack_public_path__ + "img/Time_To_Renew_Logo.e2a19d27.png";